export default __webpack_public_path__ + "static/media/avatar1.d37df039.jpeg";